import React, { useContext, useState, useEffect } from 'react';
//import { Banner } from '../banner/banner.tsx'
import { ResumenDia } from '../resumendia/ResumenDia.tsx'
import { ResumenTransaccion } from '../resumentransaccion/ResumenTransaccion.tsx'
import authContext from '../../context/auth/authContext.js'
import './dashboard.css';
import { getDashboardUseCase, getSkuDetailUseCase, sellUseCase } from '../../di/usecase_module';
import { handleError } from '../../presentation/utils/handleError';
import { ButtonDashboardGroupSku } from '../btn_sku/ButtonDashboardGroupSku.tsx';
import { useSelector, useDispatch } from 'react-redux';
import { ReporteMovs } from '../reportes/ReporteMovs.tsx';
import { SaleModal } from '@movivendor/mv-components';
import { GetSkuDetailRequestDto } from '../../domain/usecases/sku/GetSkuDetailUseCase';
import { RequestParam } from '../../domain/models/RequestParam';
import logo from '../../assets/img/logo-final.svg';
import { fetchClientDebt } from '../action/fetchClientDebt';
import { WhatsappMessageSimple } from '../action/whatsappMessage.js';
import { BalanceActions } from '../../presentation/redux/actions/BalanceActions';

function Dashboard() {
  const AuthContext = useContext(authContext);
  const { token, tipo_modelo } = AuthContext;
  const dispatch = useDispatch();
  const [groups, setGroups] = useState([]);
  const resume = useSelector((s) => s.balanceState.balance);

  const [isSaleModalOpen, setIsSaleModalOpen] = useState(false);
  const [selectedSku, setSelectedSku] = useState(undefined);
  const [saleModalTitle, setSaleModalTitle] = useState('');
  const [saleModalOptions, setSaleModalOptions] = useState(undefined);
  const [logoUrl, setLogoUrl] = useState(logo);
  const [currentOpId, setCurrentOpId] = useState(null);

  useEffect(() => {
    setLogoUrl(logo);
  }, []);

  const { pendiente_2fa } = resume;

  const handleOpenSaleModal = (sku, title, options) => {
    setSelectedSku(sku);
    setSaleModalTitle(title);
    setSaleModalOptions(options);
    setIsSaleModalOpen(true);
  };

  const handleCloseSaleModal = () => {
    setSelectedSku(undefined);
    setSaleModalTitle('');
    setSaleModalOptions(undefined);
    setIsSaleModalOpen(false);
  };

  const handleSkuSelect = async (sku) => {
    try {
      const response = await getSkuDetailUseCase().execute(
        new GetSkuDetailRequestDto(sku.sku)
      );
      return response.elements || [];
    } catch (error) {
      throw error;
    }
  };

  const handleProcessPayment = async (params, debtData) => {
    try {
      const localParams = params.map(p => new RequestParam(
        p.name,
        p.value,
        p.description,
        p.isHidden,
        p.subprod || 0
      ));

      const clientDebtParam = localParams.find(p => p.name === 'clientDebt');
      const amountParam = localParams.find(p => p.name === 'amount');

      if (clientDebtParam || (debtData && debtData.op_id) || currentOpId) {
        const op_id = debtData?.op_id || currentOpId;
        const debt_id = debtData?.selectedDebt?.id || clientDebtParam?.value;
        const debt_amount = debtData?.selectedDebt?.amount || amountParam?.value || '';

        if (debt_id && op_id) {
          const attrParts = [
            `op_id:${op_id}`,
            `debt_id:${debt_id}`,
            `debt_amount:${debt_amount}`
          ];

          localParams.push(new RequestParam('attr', attrParts.join('|'), 'Atributos de deuda', true));

          if (!localParams.some(p => p.name === 'ref')) {
            localParams.push(new RequestParam('ref', '', 'Referencia', true));
          }
        }
      }

      const response = await sellUseCase().execute(localParams);
      dispatch(BalanceActions.updateBalance(token));

      return response.elements || [];
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    const getData = () => {
      getDashboardUseCase().execute().then((result) => {
        setGroups(result);
      }).catch((e) => {
        handleError(e);
      })
    }
    getData()
  }, [token]);

  const handleFetchClientDebt = async (params) => {
    try {
      const result = await fetchClientDebt(token, params);
      if (result?.op_id) {
        setCurrentOpId(result.op_id);
      }
      return result;
    } catch (error) {
      handleError(error);
      throw error;
    }
  };

  // var x = document.getElementsByTagName("body")
  // x[0].setAttribute("style", "background:white;")

  return (
    <>
      <div className="row">
        {/* vender mensajes */}
        <div className="col-xl-8 mt-3">
          {pendiente_2fa &&
            <div className="alert alert-warning" role="alert">
              <h4 className="alert-heading">¡Pendiente de Activación 2FA!</h4>
              <small>
                Hemos enviado un correo electrónico a tu dirección con instrucciones para completar el proceso de activación del 2FA. Por favor, revisa tu bandeja de entrada.
              </small>
              <hr />
              <small className="mb-0">Si no recibes el correo en unos minutos, asegúrate de verificar la carpeta de spam y revisa que la dirección de correo proporcionada sea correcta.</small>
            </div>
          }

          {/* <Banner /> */}
          <div className="row">
            <div className="col-md-9 mt-3">
              <h3><small className="text-muted text-left pt-3 pl-5 pb-0 mb-0">Vender</small></h3>
            </div>
          </div>
          {
            groups.map((group) => {
              return <ButtonDashboardGroupSku
                key={group.groupName}
                data={group}
                onOpenSaleModal={handleOpenSaleModal}
              />
            })
          }

        </div>
        <div className=" col-lg-12 col-xl-4 pb-4">
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-lg-6 col-xl-12">
                <ResumenDia />
              </div>
              <div className="col-md-6 col-lg-6 col-xl-12">
                <ResumenTransaccion />
              </div>
              {
                (tipo_modelo) &&
                <div className="col-md-6 col-lg-6 col-xl-12">
                  <ReporteMovs />
                </div>
              }
            </div>
          </div>
        </div>
      </div>

      <SaleModal
        isOpen={isSaleModalOpen}
        onClose={handleCloseSaleModal}
        setup={{
          title: saleModalTitle,
          sku: selectedSku,
          options: saleModalOptions,
        }}
        onSkuSelect={handleSkuSelect}
        onProcessPayment={handleProcessPayment}
        onFetchClientDebt={handleFetchClientDebt}
        logoUrl={logoUrl}
        onSendReceipt={async (phone, dni, opId) => {
          console.log('Enviando a:', phone, dni, opId);
          const response = await WhatsappMessageSimple(token, {
            number: phone,
            document: dni,
            op_id: opId
          });
          console.log(response)
          return response;
        }}
      />
    </>
  );
}
export default Dashboard;